<template>
  <div class="page-card">
    <div class="page-head">
      <h3>Coach List</h3>
    </div>

    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="Keyword">
        <el-input v-model="query.keyword" clearable placeholder="Name / username / email / ID" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="Status">
        <el-select v-model="query.status" clearable placeholder="All">
          <el-option label="Active" value="0" />
          <el-option label="Disabled" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">Search</el-button>
        <el-button @click="resetSearch">Reset</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" v-loading="loading" border size="small">
      <el-table-column prop="userId" label="ID" width="80" />
      <el-table-column label="Coach Name" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" @click="openAthletes(scope.row)">{{ scope.row.nickName || scope.row.username }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="Username" min-width="130" />
      <el-table-column prop="email" label="Email" min-width="190" show-overflow-tooltip />
      <el-table-column prop="phone" label="Phone" min-width="130" />
      <el-table-column prop="athleteCount" label="Linked Users" width="120" />
      <el-table-column prop="firstLinkedAt" label="First Linked At" min-width="160" />
      <el-table-column prop="status" label="Status" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'" size="small">
            {{ scope.row.status === '0' ? 'Active' : 'Disabled' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="130" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openAthletes(scope.row)">Athlete List</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <el-dialog :title="athleteDialogTitle" :visible.sync="athleteVisible" width="860px">
      <el-table :data="athletes" v-loading="athleteLoading" border size="small">
        <el-table-column prop="userId" label="User ID" width="90" />
        <el-table-column label="Athlete" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.athleteName || scope.row.nickName || scope.row.username }}</template>
        </el-table-column>
        <el-table-column prop="email" label="Email" min-width="190" show-overflow-tooltip />
        <el-table-column prop="coachLinkedAt" label="Linked At" min-width="160" />
        <el-table-column prop="status" label="Status" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === '0' ? 'Active' : 'Disabled' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="athleteVisible=false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { coachApi } from '@/api/system'

const emptyQuery = () => ({ pageNum: 1, pageSize: 10, keyword: '', status: '' })

export default {
  name: 'CoachList',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: emptyQuery(),
      athleteVisible: false,
      athleteLoading: false,
      athleteDialogTitle: 'Athlete List',
      athletes: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await coachApi.list(this.query)
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetSearch() {
      this.query = emptyQuery()
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    async openAthletes(row) {
      this.athleteDialogTitle = `Athlete List - ${row.nickName || row.username}`
      this.athleteVisible = true
      this.athletes = []
      this.athleteLoading = true
      try {
        const res = await coachApi.athletes(row.userId)
        this.athletes = res.data || []
      } finally {
        this.athleteLoading = false
      }
    }
  }
}
</script>

<style scoped>
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.search-form { margin-bottom: 12px; }
.pager { margin-top: 16px; text-align: right; }
</style>
